// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString

function toLocaleStringSupportsOptions() {
  return !!(
    typeof Intl === "object" &&
    Intl &&
    typeof Intl.NumberFormat === "function"
  );
}

export const formatCurrency = n =>
  n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });

export default {
  formatCurrency,
  toLocaleString: (num, locale = null, options = null) => {
    if (!num.toLocaleString) {
      return num;
    }

    if ((!locale && !options) || !toLocaleStringSupportsOptions()) {
      return num.toLocaleString();
    }

    if (locale && options) {
      return num.toLocaleString(locale, options);
    } else if (locale) {
      return num.toLocaleString(locale);
    }

    return num.toLocaleString(options);
  }
};
